import React from 'react';
import {Redirect} from "react-router";
import {LINK} from "../../utils/Links";


const RootPageContainer = () => {

    return <Redirect to={LINK.HOME}/>
};

export default RootPageContainer;